import { CSSProperties } from 'react'
import css from './divider.module.css'

interface IProps {
  style?: CSSProperties
}

const Divider = (props: IProps) => {
  return (
    <div className={css.container}>
      <span style={props.style} className={css.divider}></span>
    </div>
  )
}

export default Divider
